export enum KioskStatus {
  Active = 'active',
  Unregistered = 'unregistered',
  UnregisteredPending = 'unregistered_pending',
  RequestPending = 'request_pending',
}
